import React from 'react';
import { Form, FormGroup, Label, Input, Button, Row, Col, Modal, ButtonToolbar } from 'reactstrap';
import Select from 'react-select';
import API from '../../../Common/api';

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import uploadIcon from '../../../../images/uploadNewIcon.svg';
import excelImage from '../../../../images/excel_image.svg';
import editIcon from '../../../../images/pencil-alt.svg';
import dustbinIcon from '../../../../images/dustbin-alt.svg';
import blueDownloadIcon from '../../../../images/blueDownloadIcon.svg';
import blackUploadIcon from '../../../../images/blackUploadIcon.svg';


import "./styles.css";
import DatePicker from "react-datepicker";
import { faDownload, faSyncAlt, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MDBDataTable } from 'mdbreact';




const urlParams = new URLSearchParams(window.location.search);
const paramValue = urlParams.get('id');
const paramValuePONum = urlParams.get('po_num');

let statusStyle;

var expected_delivery_date;


class HorizontalForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            employeeCode: '',
            failedModal: false,
            selectedFileInvoice: null,
            modalAddItem: false,
            modalNew: false,
            supplierCodeData: [],
            expected_delivery_date: null,
            editingIndex: null, // to track which row is being edited
            divisionList: [],
            subCategoryList: [],
            posts: [],
            fullName: '',
            email: '',
            mobile: '',
            city: '',
            role: null,
            discountError: false,
            tax_type: "",
            confirmModal: false,
            dataHistory: [],
            tax_community: "",
            warehousesList: [],
            brandList: [],
            inventoryOwner: null,
            uploadedFileName: "",
            sectionStatus: {
                pricingDetails: false,
            },
            dropDownData: [],
            warehouses: [],
            warehouses_val: [],
            availableRoles: [],
            taxType: [],
            availableOwners: [],
            invoice_changes: false,
            taxCommunity: [],
            username_val: '',
            itemDetails: [],
            password: '',
            errors: {},
            poDetails: [],
            productAttributes: [],
            productPricing: [],
            uomDetails: [],
            isAccordionOpen: false,
            sectionStatus: {
                itemDetails: false,
                productAttributes: false,
                pricingDetails: false,
                uomDetails: false
            }
        };
    }

    Failedtoggle = () => {
        this.setState((prevState) => ({ failedModal: !prevState.failedModal }));
    }
    removeItem = (indexToRemove, item_code) => {
      /*this.setState((prevState) => ({
        posts: prevState.posts.filter((_, index) => index !== indexToRemove),
        confirmModal: false
      }));*/
      let newPostData =  this.state.posts.filter((_, index) => index !== indexToRemove)
     
      const totalAmount = newPostData.reduce((sum, item) => {
        const mrpVal = parseFloat(item.mrp) || 0;
        const qtyVal = parseFloat(item.quantity) || 0;
        return sum + (mrpVal * qtyVal);
      }, 0);
      /*const billLevelDiscount = newPostData.reduce((sum, item) => {
        const billDiscountVal = parseFloat(item.item_level_discount) || 0;
        const qtyVal = parseFloat(item.quantity) || 0;
        return sum + (billDiscountVal * qtyVal);
      }, 0);*/
       this.setState((prevState) => ({
        posts: newPostData,
        total_bill_amount: totalAmount,
        confirmModal: false
        //bill_level_discount: billLevelDiscount

      }));

       if(newPostData.length === 0){
        this.removeUploadedFile();
       }
    };

    toggleAddItem = () => {
        this.setState((prevState) => ({ modalAddItem: !prevState.modalAddItem }));
    }

    toggleNew = () => {
        this.setState((prevState) => ({ modalNew: !prevState.modalNew }));
    }

    toggleBack = () => {
        window.location.href = "/receiving/purchase_order";  
    }
    toggleCancel = () => {
        window.location.href = "/receiving/view_single_po_details?tab=po_list&id="+paramValue+"&po_num="+paramValuePONum;  
    }
    getSupplierCode = ()=>{
        API.get('/receiving/po-creation/supplier')
        .then((response) => response.data)

        .then((data) => {
          console.log("Supplier",data);
          this.setState({ supplierCodeData: data.data });
        })

        .then(async () => {
          
        });

    }

    getSubCategory = () => {
    
        API.get('/receiving/po-creation/sub-category')
        .then((response) => response.data)

        .then((data) => {
          console.log("brand",data);
          
          this.setState({ subCategoryList: data.data });
        })

        .then(async () => {
          
        });
    }

    handleAddItemSubmit = () => {
      const {
        editingIndex,
        item_code,
        item_description,
        mrp,
        item_level_discount,
        quantity,
        pre_tax,
        post_tax,
        uom,
        cost,
        posts
      } = this.state;

      const newItem = {
        item_code,
        item_description,
        mrp,
        item_level_discount,
        quantity,
        pre_tax,
        post_tax,
        uom,
        cost,
      };

      let updatedPosts = [];

      if (editingIndex !== null) {
        // ✅ Update existing item
        updatedPosts = [...posts];
        updatedPosts[editingIndex] = { ...newItem, sno: editingIndex + 1 };
      } else {
        // ✅ Add new item
        updatedPosts = [...posts, { ...newItem, sno: posts.length + 1 }];
      }

      // ✅ Recalculate totalAmount (mrp * quantity for all items)
      const totalAmount = updatedPosts.reduce((sum, item) => {
        const mrpVal = parseFloat(item.mrp) || 0;
        const qtyVal = parseFloat(item.quantity) || 0;
        return sum + (mrpVal * qtyVal);
      }, 0);
      /*const billLevelDiscount = updatedPosts.reduce((sum, item) => {
        const billDiscountVal = parseFloat(item.item_level_discount) || 0;
        const qtyVal = parseFloat(item.quantity) || 0;
        return sum + (billDiscountVal * qtyVal);
      }, 0);*/

      // ✅ Update state
      this.setState({
        posts: updatedPosts,
        total_bill_amount: totalAmount,
        //bill_level_discount: billLevelDiscount,
        editingIndex: null,
        modalAddItem: false,

        // Reset form fields
        item_code: '',
        item_description: '',
        mrp: '',
        item_level_discount: '',
        quantity: '',
        pre_tax: '',
        post_tax: '',
        uom: '',
        cost: '',
      });
    };

    invoiceFileUpload = (event) => {
      const file = event.target.files[0];
      console.log(file);
      
      if (file && file.type === "application/pdf") {
        this.setState({ selectedFileInvoice: file });

        const reader = new FileReader();
        reader.onload = (e) => {
          const base64PDF = e.target.result;
          console.log("PDF file uploaded:", file.name);

          // You can later send this base64PDF to backend or display in iframe
          this.setState({ pdfDataUrl: base64PDF, invoice_changes: true });
        };

        reader.readAsDataURL(file); // To preview or send to server as base64
      } else {
        this.setState({
          selectedFileInvoice: null,
          pdfDataUrl: null,
          invoice_changes: false
        });
        alert("Please upload a valid PDF file.");
      }
    };

    insertAddItemButton = () => {
        
        this.insertButtonInterval = setInterval(() => {
        const targetDiv = document.querySelector('div[data-test="datatable-search"]');
        const searchInputDiv = document.querySelector('div[data-test="datatable-input"]');
        const refDiv = document.querySelector('div[data-test="datatable-entries"]');

        // Safeguard: Only proceed if refDiv exists
        if (refDiv) {
          // Check if the heading text already exists inside refDiv
          const alreadyExists = Array.from(refDiv.childNodes).some(node =>
            node.textContent && node.textContent.trim() === "PO Line items"
          );

          if (!alreadyExists) {
            const span = document.createElement('span');
            span.innerHTML = '<strong style={{fontSize: 18}}>PO Line items</strong>';
            span.style.marginRight = '10px';
            span.style.fontSize = '16px';
            refDiv.insertBefore(span, refDiv.firstChild);
          }
        }


        if (targetDiv && searchInputDiv && !document.getElementById('add-new-item-button')) {
          const button = document.createElement('button');

          button.innerText = '➕ Add New Item';
          button.id = 'add-new-item-button';
          button.style.border = '1px solid #FFCB05';
          button.style.background = 'white';
          button.style.color = '#333';
          button.style.fontWeight = '500';
          button.style.padding = '9px 12px';
          button.style.borderRadius = '8px';
          button.style.fontSize = '14px';
          button.style.cursor = 'pointer';
          button.style.marginRight = '12px';

         const self = this;

         button.addEventListener('click', function () {
            self.addItemModal();
          });

          targetDiv.insertBefore(button, searchInputDiv);
          clearInterval(this.insertButtonInterval);
        }
      }, 300);
    };


    /*handleChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value, errors: { ...this.state.errors, [name]: '' } });
    };*/
    /*handleChange = (event) => {
        const { name, value } = event.target;
        this.setState(
            { [name]: value, errors: { ...this.state.errors, [name]: '' } },
            () => {
                this.setState({
                    sectionStatus: {
                        itemDetails: this.isSectionComplete('itemDetails'),
                        productAttributes: this.isSectionComplete('productAttributes'),
                        pricingDetails: this.isSectionComplete('pricingDetails'),
                        uomDetails: this.isSectionComplete('uomDetails'),
                    }
                });
            }
        );
    };*/
    handleChange = (e) => {
        const { name, value } = e.target;

        // Update supplier_code in state
        if(name === "item_level_discount"){
            if(value >= this.state.mrp ){
                this.setState({
                  discountError: true  
                })
                return false;
            }else{
                this.setState({
                    discountError: false
                })
            }
        }
        this.setState({ [name]: value });

        // If the changed field is supplier_code, find selected supplier details
        if (name === "supplier_code") {
            const selectedSupplier = this.state.supplierCodeData.find(
                (item) => item.name === value
            );

            if (selectedSupplier) {
                console.log('selectedSupplier', selectedSupplier.name)
                this.setState({
                    vendor_name: selectedSupplier.name,
                    trade_name: selectedSupplier.trade_name,
                    location: selectedSupplier.location,
                    selected_supplier_id: selectedSupplier.id,
                    full_address: selectedSupplier.customer_addresses && selectedSupplier.customer_addresses[0]  ? selectedSupplier.customer_addresses[0] : ""
                });
            } else {
                this.setState({
                    vendor_name: "",
                    trade_name: "",
                    selected_supplier_id: "",
                    full_address: "",
                });
            }

            console.log("Details",selectedSupplier.id, selectedSupplier.customer_addresses[0])
        }
    };
    isSectionComplete = (section) => {
        switch (section) {
            case 'itemDetails':
                return (
                    this.state.item_code &&
                    this.state.item_name &&
                    this.state.item_type &&
                    this.state.item_category &&
                    this.state.sub_category &&
                    this.state.brand &&
                    this.state.sub_brand &&
                    this.state.hsn_code &&
                    this.state.hht_item_desc
                );
            case 'productAttributes':
                return (
                    this.state.ean &&
                    this.state.upc &&
                    this.state.ean_each_length &&
                    this.state.ean_each_breadth &&
                    this.state.ean_each_height 
                );
            case 'pricingDetails':
                return (
                    this.state.mrp &&
                    this.state.std_cost &&
                    this.state.per_qty
                );
            case 'uomDetails':
                return (
                    this.state.purchase_uom &&
                    this.state.std_purchase_price &&
                    this.state.sales_uom
                );
            default:
                return false;
        }
    };

    convertDate = (inputDate) => {
        const pad = (s) => (s < 10 ? '0' + s : s);
        const d = new Date(inputDate);
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    };

  // Date change handler
    ExpectedDateChange = (date) => {
        if (date) {
          const formatted = this.convertDate(date);
          console.log("Expected date (formatted):", formatted);

          this.setState({
            expected_delivery_date: date, // keep it as a Date object for DatePicker
            formatted_delivery_date: formatted,
            loading: !this.state.loading,
          });
        } else {
          this.setState({
            expected_delivery_date: null,
            loading: false,
          });
        }
    };

    componentDidMount() {
        this.getDropDownData();
        this.fetchBinData();
        this.getSupplierCode();
        this.insertAddItemButton();
        this.getBrand();
        this.getWarehouseData();
        this.getSubCategory();
         window.toggleNewModal = this.toggleAddItem; 
         const accordion = document.getElementById("create_item_accordian");
         const accordion_buttons = document.getElementsByClassName("accordion__button");
         const accordion_items = document.getElementsByClassName("accordion__item");
         const accordion__panel = document.getElementsByClassName("accordion__panel");

        if (accordion) {
            accordion.style.setProperty("width", "92%", "important");
            accordion.style.setProperty("border", "0px", "important");
        }


        if (accordion_buttons.length > 0) {  // Check if elements exist
            for (let button of accordion_buttons) {
                button.style.setProperty("background-color", "#fff", "important");
                button.style.setProperty("font-weight", "bold", "important");
            }

        }

        if (accordion_items.length > 0) {  // Check if elements exist
            for (let button of accordion_items) {
                button.style.setProperty("margin-bottom", "10px", "important");
                button.style.setProperty("border", "0px", "important");
                
            }

        }

         if (accordion__panel.length > 0) {  // Check if elements exist
            for (let button of accordion__panel) {
                button.style.setProperty("background-color", "#fff", "important");
                
                
            }

        }
    }

    fetchBinData(page = 1){
      this.setState({
        showFetchBinData: true,
        showFetchBaseData: false,
        showFetchProductData: false,
        showFetchTesterData: false,
        loading_overlay:true
      })

      const url = `/receiving/po-creation/${paramValue}`;
      API.get(url)
      /*callapiobj.get('/tax/v1/item-list/product/', { param: payload })*/

      .then(response => response.data)

      .then(data => {

         console.log("PO Data",data);
         var obj = {};

         /*var splitedWarehouse = [];*/

         obj['name'] = data.data.invoice_attachment
         const dateString = data.data.expected_delivery_date; // e.g., "2025-05-26"
         const expectedDate = dateString ? new Date(dateString) : null;

         if(data.data.warehouse){
            var splitedWarehouse = data.data.warehouse.code. split("||");
            console.log('splitedWarehouse', splitedWarehouse)
         }
         
         console.log('splitedWarehouse12',data.data.warehouse.code.split("||")[0]);
         this.setState({
            poDetails: data.data,
            posts: data.data.po_items,
            selectedFileInvoice: obj,
            sub_category: data.data.sub_category,
            division: data.data.division,
            expected_delivery_date: expectedDate,
            formatted_delivery_date: data.data.expected_delivery_date,
            supplier_code: data.data.supplier_code.name,
            full_address: data.data.supplier_code.customer_addresses[0],
            notes_description: data.data.notes_description,
            total_bill_amount: data.data.total_bill_amount,
            bill_level_discount: data.data.bill_level_discount,
            brand: data.data.warehouse ? data.data.warehouse.code.split("||")[1] : "",
            warehouse: data.data.warehouse ? data.data.warehouse.code.split("||")[0] : "",
            /*productAttributes: data.data.product_attributes,
            productPricing: data.data.product_pricing,
            uomDetails: data.data.uom_details,
            dataHistory: data.data.data_history,*/
         })

      })

      .then(async() => {

         this.setState({ tableRows:this.assemblePosts(), loading_overlay:false })

         console.log(this.state.tableRows);

      });
    }
    confirmToggle = (index, item_code) => {
        this.setState((prevState) => ({ confirmModal: !prevState.confirmModal, itemIndex: index, itemCode: item_code, confirmMessage: (
      <>
        Are you sure want to remove the <strong>Item - </strong> <strong>{item_code}</strong> from list ?
      </>
    ) }));

    }

    addItemModal = ()=>{
        //alert("hi");
        console.log("ADD Item")
        this.setState({
            editingIndex: null,
            modalAddItem: true,
            modalHeading: 'Add New Item',
            sl_num: this.state.posts.length +1,
            item_code: "",
            item_description: "",
            mrp: "",
            item_level_discount: "",
            quantity: "",
            pre_tax: "",
            post_tax: "",
            cost: "",
            uom: "",
            


        })
        //this.toggleNewModal()
    }

    editItem = (index, item) => {
        console.log('Edit Item',item)
      this.setState({
        editingIndex: index,
        sl_num: index + 1, // or item.sl_num if present
        item_code: item.item_code,
        item_description: item.item_description,
        mrp: item.mrp,
        item_level_discount: item.item_level_discount,
        quantity: item.quantity,
        pre_tax: item.pre_tax,
        post_tax: item.post_tax,
        uom: item.uom,
        cost: item.cost,
        modalHeading: 'Edit Item',
        modalAddItem: true,
      });
    };

    assemblePosts= () => {
    

        let posts =this.state.posts.map((post, index) => {

        return (

        {
          

          sl_no: index+1,
          item_code: post.item_code,
          item_desc: post.item_description,
          mrp: post.po_date,
          item_level_discount: post.item_level_discount,
          qty: post.qty,
          per_tax: post.per_tax,
          post_tax: post.post_tax,
          uom: post.uom,
          cost: post.cost,
          action: (
                <div className="action-menu">
                  <button className="action-menu-button">⋮</button>
                  <div className="action-menu-content">
                    <div style={{fontSize: 12}} onClick={() => this.removeItem(index)}><img style={{width: '11%', marginRight: 6}} src={dustbinIcon} />Remove Item</div>
                    <div style={{fontSize: 12}} onClick={() => this.editItem(index,post)}><img style={{width: '11%', marginRight: 6}} src={editIcon} /> Edit Item</div>
                    
                  </div>
                </div>
            )

          

        }

      )

    });

    this.setState({
      loading_overlay: false
    })

    return posts;

  }

   updateItem = () => {
        this.setState({ loading: true });

        const payload = {
            expected_delivery_date: this.state.formatted_delivery_date,
            sub_category: this.state.sub_category,
            division: this.state.division,
            total_bill_amount: this.state.total_bill_amount,
            bill_level_discount: this.state.bill_level_discount,
            term_condition: this.state.poDetails.term_condition,
            notes_description: this.state.notes_description,
            warehouse_code: this.state.warehouse,
            brand: this.state.brand,
            supplier: this.state.supplier_code,
            po_items: this.state.posts,
        };
        const url = `/receiving/po-creation/${paramValue}`;

        API.patch(url, { param: payload })
        .then((response) => {
          console.log("Created PO Data", response);
          const { data, status } = response;
          console.log(data.status, data, data.data)

          if ((status === 200|| data.status === true) && data.data.id) {
            const poId = data.data.id;
        /*const invoiceFile = this.state.selectedFileInvoice;

        if (invoiceFile) {
          const formData = new FormData();
          formData.append("invoice", invoiceFile);

          // Upload the invoice
          return API.post(`/receiving/po-creation/invoice/${poId}`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: this.props.auth_token || localStorage.getItem("auth_token")
            },
          })
            .then((uploadResponse) => {
              console.log("Invoice uploaded", uploadResponse);

              this.setState({
                success_message: uploadResponse.data.message || data.message,
                modalNew: true,
                loading: false,
              });
            })
            .catch((uploadError) => {
              console.error("Invoice Upload Error", uploadError);
              this.setState({
                success_message: "PO created, but invoice upload failed.",
                modalNew: true,
                loading: false,
              });
            });
        }*/

        if(this.state.invoice_changes === true){

            const invoiceFile = this.state.selectedFileInvoice;

                if (invoiceFile) {
                  const formData = new FormData();
                  
                    formData.append("invoice", this.state.selectedFileInvoice);

                    API.post2(`/receiving/po-creation/invoice/${poId}`, {
                      param: formData,
                    })
                    .then((uploadResponse) => {
                        console.log("Invoice uploaded", uploadResponse);
                        this.setState({
                          success_message: uploadResponse.data.message,
                          modalNew: true,
                          loading: false,
                        });
                    })
                    .catch((uploadError) => {
                        console.error("Invoice Upload Error", uploadError);
                        this.setState({
                          success_message: "PO created, but invoice upload failed.",
                          modalNew: true,
                          loading: false,
                        });
                    });

                }
        }


            // If no file was selected, just show PO creation success
            this.setState({
              success_message: data.message,
              modalNew: true,
              loading: false,
            });
          } else {
            this.setState({
              failed_message: data.message,
              failedModal: true,
              loading: false,
            });
          }
        })
        .catch((error) => {
           if (error.response && error.response.status === 400) {
            const errorData = error.response.data;
            const errors = errorData.data ? Object.values(errorData.data).flat() : [];

            const formattedErrorString = errors.join(', '); // Only values, comma-separated

            this.setState({
              failed_message: formattedErrorString,
              failed_errors: errors,
              failedModal: true,
              loading: false,
            });
          } else {
            console.error(error);
            this.setState({ loading: false });
          }
        });
    };


   removeInvoiceUploadedFile = () => {
        this.setState({ selectedFileInvoice: null, postsInvoice: [], pdfDataUrl: null, });
    };


    handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            console.log("File selected:", file.name);
            // You can update state or handle file upload here
        }
    };

    getBrand = () => {
    
        API.get('/tax/v1/filter/brands')
        .then((response) => response.data)

        .then((data) => {
          console.log("brand",data);
          
          this.setState({ brandList: data.data });
        })

        .then(async () => {
          
        });
    }

    getWarehouseData = () => {
        API.get('/receiving/po-creation/warehouse-list')
            .then((response) => response.data)
            .then((data) => {
                
                console.log("Warehouse", data)
                this.setState({
                    warehousesList: data.data
                })
            })
            .catch((error) => console.error(error));
    };

    getDropDownData = () => {
        API.get('/tax/v1/item-list/product/dropdown/')
            .then((response) => response.data)
            .then((data) => {
                
                this.setState({
                    dropDownData: data.data,
                    divisionList: data.data.division
                })
            })
            .catch((error) => console.error(error));
    };

   
      handleAccordionToggle = (isOpen) => {
        this.setState({ isAccordionOpen: isOpen });
    };

    render() {
        const { errors, modalNew, failedModal, dropDownData, poDetails, productAttributes, uomDetails, productPricing, dataHistory, itemDetails, selectedFileInvoice,modalAddItem, posts, confirmModal } = this.state;
        console.log()
        const isActive = itemDetails.status == 3;
        if(poDetails.status){
            const status = poDetails.status.value;
              statusStyle = {
                display: 'inline-block',
                padding: '4px 12px',
                borderRadius: '12px',
                fontSize: '12px',
                fontWeight: 600,
                color: '#000',
                backgroundColor: '#f0f0f0',
              };

              if (status === "Approved") {
                statusStyle = {
                  ...statusStyle,
                  backgroundColor: '#E6F4EA', 
                  color: '#34A853',          
                };
              } else if (status === "Pending for Approval") {
                statusStyle = {
                  ...statusStyle,
                  backgroundColor: '#FEF1CC', 
                  color: '#FB8C00',           
                };
              }else if (status === "Rejected") {
                statusStyle = {
                  ...statusStyle,
                  backgroundColor: '#FF3C00', 
                  color: '#FFF0EF',           
                };
              }else if (status === "Cancelled") {
                statusStyle = {
                  ...statusStyle,
                  backgroundColor: '#E6E6E6', 
                  color: '#777777',           
                };
              }else if (status === "In Progress") {
                statusStyle = {
                  ...statusStyle,
                  backgroundColor: '#E8F1FF', 
                  color: '#5C9DFF',           
                };
              }



        }
         

        const data = {

          columns: [

            {

              label:'S.NO',

              field:'sl_no',
              sort: '',
              width: 50

            },

            {

              label:'Item Code',

              field:'item_code',
              sort: '',
              width: 100

            },
            {

              label:'Item Desc',

              field:'item_desc',
              sort: '',
              width: 130

            },
            {

              label:'MRP',

              field:'mrp',
              sort: '',
              width: 80

            },

            {

              label:'Item Level Discount',

              field:'item_level_discount',
              sort: '',
              width: 150

            },

            {

              label:'QTY',

              field:'qty',
              sort: '',
              width: 80

            },
           
           {

              label:'Pre Tax',

              field:'pre_tax',
              sort: '',
              width: 100

            },
           
           {

              label:'Post Tax',

              field:'post_tax',
              sort: '',
              width: 100

            },

            {
              label:'UOM',

              field:'uom',
              sort: '',
              width: 100

            },

            {
              label:'Cost',

              field:'cost',
              sort: '',
              width: 100

            },

            {
              label:'',

              field:'action',
              sort: '',
              width: 100

            },
           
           


            

          ],

          rows:this.state.tableRows,

        }



        return (
            <div id="createItem_container" style={{ width: '100%', margin: '1%' }}>
                {/*<div className="statusStyle" >
                    <span  className="dotStyle"></span>
                    <span style={{ color: isActive ? 'green' : 'red', fontWeight: 'bold' }}>
                        {isActive ? 'Active' : 'Inactive'}
                    </span>
                </div>*/}

                
                
                    <Accordion 
                        id="create_item_accordian" 
                       style={{ width: '100%', maxWidth: '100vw' }} 
                        allowMultipleExpanded 
                        allowZeroExpanded
                        onChange={(expandedItems) => this.handleAccordionToggle(expandedItems.length > 0)}
                    >
                        {/* Section 1 */}
                        <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton id="accordion_button">
                                    <span className="accordian_title">Request Details</span>
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="username">PO Number </Label>
                                            <Input
                                                type="text"
                                                name="po_number"
                                                value={poDetails.po_number}
                                                onChange={this.handleChange}
                                                required
                                                disabled
                                            />
                                        </FormGroup>
                                    </Col>

                                     <Col md={4}>
                                        <FormGroup>
                                            <Label for="city">Warehouse </Label>
                                            <select
                                                name="warehouse"
                                                className="form-control"
                                                value={this.state.warehouse}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                            >
                                                <option value="">{this.state.warehouse}</option>
                                                {this.state.warehousesList.map((item) => (
                                                
                                                    <option key={item.id} value={item.code}>{item.code}</option>
                                                ))}
                                            </select>
                                        </FormGroup>
                                    </Col>
                                     <Col md={4}>
                                        <FormGroup>
                                            <Label for="city">Brand </Label>
                                            <select
                                                name="brand"
                                                className="form-control"
                                                value={this.state.brand}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                            >
                                                <option value="">{this.state.brand}</option>
                                                {this.state.brandList.map((item) => (
                                                
                                                    <option key={item.id} value={item.code}>{item.code}</option>
                                                ))}
                                            </select>
                                        </FormGroup>
                                    </Col>
                                    

                                </Row>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="username">Expected Delivery Date </Label>
                                            <div id="date_picker_container" style={{ position: 'relative' }}>
                                                <DatePicker
                                                  id="ledger_fromdate"
                                                  selected={this.state.expected_delivery_date}
                                                  onChange={this.ExpectedDateChange}
                                                  className="ledger_fromdate"
                                                  placeholderText="Expected Delivery Date"
                                                  format='yyyy-MM-dd'                                                 minDate={new Date()}
                                                  
                                              />
                                              <i className="fa fa-calendar" style={{ position: 'absolute', right: '10px', top: '10px', pointerEvents: 'none' }}></i>
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="city">Sub Category </Label>
                                            <select
                                                name="sub_category"
                                                className="form-control"
                                                value={this.state.sub_category}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                                
                                            >
                                                <option value={poDetails.sub_category}>{poDetails.sub_category}</option>
                                                {this.state.subCategoryList.map((item) => (
                                                    <option key={item} value={item}>{item}</option>
                                                ))}
                                            </select>
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="city">Division</Label>
                                            <select
                                                name="division"
                                                className="form-control"
                                                value={this.state.division}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                                
                                            >
                                                <option value="">{poDetails.division}</option>

                                                {/*<option value={dropDownData.division}>{dropDownData.division}</option>
*/}
                                                {this.state.divisionList.map((item) => (
                                                    <option key={item} value={item}>{item}</option>

                                                ))}
                                            </select>
                                        </FormGroup>
                                    </Col>

                                </Row>

                                <Row>
                                    <Col md={4}>
                                        
                                            <Label for="city">PO Date </Label>
                                            <div id="date_picker_container" style={{ position: 'relative' }}>
                                              <DatePicker
                                                  id="ledger_fromdate"
                                                  selected={poDetails.po_date ? new Date(poDetails.po_date) : null}
                                                  onChange={this.FromDateChange}
                                                  className="ledger_fromdate"
                                                  placeholderText="PO Date"
                                                  format='yyyy-MM-dd'
                                                  disabled
                                              />
                                              <i className="fa fa-calendar" style={{ position: 'absolute', right: '10px', top: '10px', pointerEvents: 'none' }}></i>
                                            </div>
                                    </Col>

                                </Row>

                            </AccordionItemPanel>
                        </AccordionItem>

                        {/* Section 2 */}
                        <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton id="accordion_button">
                                    <span className="accordian_title">Vendor Information</span>
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="email">Supplier Code</Label>
                                            <select
                                                className="form-control"
                                                value={this.state.supplier_code}
                                                style={{ fontSize: 13 }}
                                                name="supplier_code"
                                                onChange={this.handleChange}
                                                
                                            >
                                                {this.state.supplierCodeData.length > 0 &&
                                                  this.state.supplierCodeData.map((items) => {
                                                    return (

                                                      <option value={items.name}>
                                                        {" "}
                                                        {items.name}
                                                      </option>
                                                    );
                                                  })}
                                            </select>
                                        </FormGroup>
                                    </Col>
                                   
                                </Row>
                                <Row form>
                                     <Col md={4}>
                                        
                                        <FormGroup>
                                            <Label for="mobile">Vendor Name</Label>
                                            <Input
                                                type="text"
                                                name="vendor_name"
                                                value={this.state.supplier_code}
                                                disabled
                                                id="mobile"
                                                onChange={this.handleChange}
                                                disabled
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Location</Label>
                                            <Input
                                                type="text"
                                                name="location"
                                                id="mobile"
                                                onChange={this.handleChange}
                                                value={this.state.location}
                                                disabled
                                            />
                                        </FormGroup>
                                    </Col>
                                     <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Trade Name</Label>
                                            <Input
                                                type="text"
                                                name="trade_name"
                                                value={this.state.supplier_code}
                                                id="mobile"
                                                onChange={this.handleChange}
                                                disabled
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>

                                 <Row form>
                                     <Col md={12}>
                                        
                                        <FormGroup>
                                            <Label for="mobile">Full Address</Label>
                                            <Input
                                                type="text"
                                                name="full_address"
                                                id="mobile"
                                                onChange={this.handleChange}
                                                value={this.state.full_address}
                                                disabled
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </AccordionItemPanel>
                        </AccordionItem>
                        <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton id="accordion_button">
                                  <span className="accordian_title">PO Bulk Upload</span>
                                </AccordionItemButton>
                            </AccordionItemHeading>

                            <AccordionItemPanel>
                                <span style={{color: 'black'}}> Items List Upload </span>
                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    alignItems: "flex-start",
                                    gap: "2rem",
                                    marginTop: 15,
                                  }}
                                >


                            

                                    {/* Right Section - Image */}
                                    {/*<div style={{ flex: 1, minWidth: "300px",  }}>
                                        <div className="file-name-container">
                                            <img
                                              src={excelImage}
                                              alt="PO Bulk Upload"
                                              style={{
                                                width: "10%",
                                                height: "auto",
                                                borderRadius: "8px",
                                                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                                marginLeft: 10
                                              }}
                                            />
                                            <span style={{color: '#33A0FF', marginLeft: 12, fontSize: 13}}>File Name</span>
                                            

                                        </div>
                                    </div>*/}
                                </div>

                                <div id="masterTableContainer" className="taxmaster_table">
                  
                                   {/* <div
                                      className="d-flex justify-content-end align-items-center"
                                      style={{ width: "100%" }}
                                    >
                                      
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search"
                                        value={this.state.searchTerm}
                                        onChange={this.handleSearchInput}
                                        onKeyDown={this.handleKeyDown}
                                        style={{ width: 200, marginRight: 10 }}
                                        id="searchInput"
                                      />

                                     
                                      {this.state.isDownlding ? (
                                        <FontAwesomeIcon
                                          icon={faSpinner}
                                          spin
                                          style={{ fontSize: "18px", color: "#919193", cursor: "not-allowed" }}
                                        />
                                      ) : (
                                        <a
                                          onClick={() => this.downloadExcel()}
                                          style={{
                                            fontSize: "18px",
                                            color: "#919193",
                                            cursor: "pointer",
                                          }}
                                        >
                                          <FontAwesomeIcon icon={faDownload} />
                                        </a>
                                      )}
                                    </div>*/}

                                   <MDBDataTable
                                    striped
                                    bordered
                                    sortable={true}
                                    hover
                                    data={{
                                      columns: [
                                        { label: 'S.NO', field: 'sno' },
                                        { label: 'Item Code', field: 'itemCode' },
                                        { label: 'Item Description', field: 'itemDescription' },
                                        { label: 'MRP', field: 'mrp' },
                                        { label: 'Item level Discount', field: 'discount' },
                                        { label: 'Quantity', field: 'quantity' },
                                        { label: 'Pre Tax', field: 'preTax' },
                                        { label: 'Post Tax', field: 'postTax' },
                                        { label: 'UOM', field: 'uom' },
                                        { label: 'Cost', field: 'cost' },
                                        { label: '', field: 'action' }
                                      ],
                                      rows: posts.map((item, index) => ({
                                        sno: index + 1,
                                        itemCode: item['item_code'],
                                        itemDescription: item['item_description'],
                                        mrp: item['mrp'],
                                        discount: item['item_level_discount'],
                                        quantity: item['quantity'],
                                        preTax: item['pre_tax'],
                                        postTax: item['post_tax'],
                                        uom: item['uom'],
                                        cost: item['cost'],
                                        action: (
                                                <div className="action-menu">
                                                  <button className="action-menu-button">⋮</button>
                                                  <div className="action-menu-content">
                                                    <div style={{fontSize: 12}} onClick={() => this.confirmToggle(index, item['item_code'])}><img style={{width: '11%', marginRight: 6}} src={dustbinIcon} />Remove Item</div>
                                                    <div style={{fontSize: 12}} onClick={() => this.editItem(index,item)}><img style={{width: '11%', marginRight: 6}} src={editIcon} /> Edit Item</div>
                                                    
                                                  </div>
                                                </div>
                                            )
                                      }))
                                    }}
                                    paging={false}
                                    searching={true}
                                  />
                  
                                </div>
                            
                            </AccordionItemPanel>
                        </AccordionItem>


                        <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton id="accordion_button">
                                    <span className="accordian_title">Total </span>
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="email">Total Bill Amount</Label>
                                            <Input
                                                type="text"
                                                name="total_bill_amount"
                                                id="email"
                                                value={this.state.total_bill_amount}
                                                
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Bill Level Discount (RPA)</Label>
                                            <Input
                                                type="text"
                                                name="bill_level_discount"
                                                id="mobile"
                                                value={this.state.bill_level_discount}
                                                
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </AccordionItemPanel>
                        </AccordionItem>

                         <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton id="accordion_button">
                                    <span className="accordian_title">Invoice Attachment </span>
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <div>
                                    <span style={{ color: 'black', fontWeight: 500 }}>Invoice Upload</span>

                                    {/* Upload Area */}
                                    <div style={{ display: 'flex', alignItems: 'center', marginTop: 16 }}>
                                      {/* Upload or File Display */}
                                      {/* Upload or File Display */}
                                        {!selectedFileInvoice ? (
                                          <div
                                            style={{
                                              display: 'flex',
                                              border: '1px solid #E4E4E7',
                                              padding: '10px 12px',
                                              borderRadius: '10px',
                                              alignItems: 'center',
                                              minWidth: 300,
                                              maxWidth: 400,
                                            }}
                                          >
                                            <span style={{ fontSize: 13, color: '#7C7C85', flex: 1 }}>Upload documents in .pdf</span>
                                            <input
                                              type="file"
                                              accept=".pdf"
                                              style={{ display: 'none' }}
                                              id="invoicefileUpload"
                                              onChange={this.invoiceFileUpload}
                                            />
                                            

                                            <label htmlFor="invoicefileUpload" style={{ fontSize: 12, color: '#121212', padding: '6px 15px', border: '1px solid #FFCB05', borderRadius: 8, cursor: 'pointer' }}>
                                              <img src={blackUploadIcon} style={{width: '22%'}} /> Attach
                                            </label>
                                          </div>
                                        ) : (
                                          <div
                                            style={{
                                              display: 'flex',
                                              alignItems: 'center',
                                              border: '1px solid #E4E4E7',
                                              padding: '8px 12px',
                                              borderRadius: '10px',
                                              backgroundColor: '#F2F4F7',
                                              minWidth: 300,
                                              maxWidth: 400,
                                            }}
                                          >
                                            <span style={{ color: '#1E90FF', fontSize: 13, flex: 1 }}>
                                              {selectedFileInvoice ? selectedFileInvoice.name : ""}
                                            </span>
                                            <button
                                              onClick={this.removeInvoiceUploadedFile}
                                              style={{
                                                border: 'none',
                                                background: 'transparent',
                                                cursor: 'pointer',
                                                fontSize: 16,
                                                color: '#777',
                                              }}
                                            >
                                              ✖
                                            </button>
                                          </div>
                                        )}
                                    </div>
                                    {this.state.fileError && (
                                      <div style={{ color: 'red', marginTop: 8 }}>
                                        {this.state.fileError}
                                      </div>
                                    )}
                                </div>
{/*
                                {this.state.pdfDataUrl && (
                                  <iframe
                                    src={this.state.pdfDataUrl}
                                    title="Invoice Preview"
                                    width="100%"
                                    height="500px"
                                    style={{ border: '1px solid #ccc', marginTop: 10 }}
                                  />
                                )}*/}



     
                                
                            </AccordionItemPanel>
                            {/*<AccordionItemPanel>
                                <Row form>
                                    <Col md={12}>
                                       <div
                                          style={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                            alignItems: "flex-start",
                                            gap: "2rem",
                                            
                                          }}
                                        >

                                            
                                            <div style={{ flex: 1, minWidth: "300px",  }}>
                                                <div className="file-name-container-view">
                                                    <img
                                                      src={excelImage}
                                                      alt="PO Bulk Upload"
                                                      style={{
                                                        width: "5%",
                                                        height: "auto",
                                                        borderRadius: "8px",
                                                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                                        marginLeft: 10
                                                      }}
                                                    />
                                                    <span style={{ marginLeft: 12, fontSize: 13}}>{poDetails.invoice_attachment ? poDetails.invoice_attachment : "No Uploaded File"}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                    
                                </Row>
                            </AccordionItemPanel>*/}
                        </AccordionItem>


                         <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton id="accordion_button">
                                    <span className="accordian_title">Terms & Condition </span>
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <Row form>
                                    <Col md={12}>
                                        <FormGroup>
                                            <Label for="email">Terms & Condition</Label>
                                            <Input
                                                type="text"
                                                name="purchase_uom"
                                                id="email"
                                                value={poDetails.term_condition}
                                                disabled
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={12}>
                                        <FormGroup>
                                            <Label for="mobile">Notes or Description</Label>
                                            <Input
                                                type="text"
                                                name="notes_description"
                                                id="mobile"
                                               
                                                value={this.state.notes_description}
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </AccordionItemPanel>
                        </AccordionItem>
                    </Accordion>
                     {this.state.isAccordionOpen && (
                    <div style={{
                       
                        bottom: 0,
                        left: 0,
                        width: '100%',
                        backgroundColor: 'white',
                        boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.1)',
                        padding: '15px 0',
                        textAlign: 'center'
                    }}>
                        <button 
                            onClick={this.toggleCancel} 
                            style={{
                                backgroundColor: 'white',
                                border: '2px solid #FBBB00',
                                color: 'black',
                                padding: '8px 22px',
                                fontSize: '16px',
                                marginRight: '10px',
                                borderRadius: '5px',
                                cursor: 'pointer'
                            }}
                        >
                            Cancel
                        </button>

                        <button 
                            onClick={this.updateItem} 
                            id="createUserBtn" 
                            style={{
                                backgroundColor: '#FBBB00',
                                border: 'none',
                                color: 'black',
                                padding: '8px 22px',
                                fontSize: '16px',
                                borderRadius: '5px',
                                cursor: 'pointer'
                            }}
                        >
                            Update
                        </button>
                    </div>
                )}


                   

                <Modal isOpen={modalNew} backdrop="static" toggle={this.toggleNew}>
                  <div className="modal__header">
                    <button
                      className="lnr lnr-cross modal__close-btn"
                      type="button"
                      style={{ right: 15 }}
                      onClick={this.toggleNew}
                    />
                  </div>
                  <div
                    className="modal__body"
                    style={{ paddingTop: 55, paddingBottom: 20 }}
                  >
                    <span
                      className="lnr lnr-thumbs-up modal__title-icon"
                      style={{ color: "#4ce1b6" }}
                    />
                    <h5>{this.state.success_message} </h5>
                    
                  </div>
                  <ButtonToolbar className="modal__footer">
                    <Button
                      style={{ backgroundColor: "#24d6a3", color: "#fff" }}
                      className="modal_ok"
                      onClick={this.toggleCancel}
                    >
                      Ok
                    </Button>
                  </ButtonToolbar>
                </Modal>

                <Modal isOpen={failedModal} backdrop="static" toggle={this.Failedtoggle}>
                    <div className="modal__header">
                      <button
                        className="lnr lnr-cross modal__close-btn"
                        type="button"
                        style={{ right: 15 }}
                        onClick={this.Failedtoggle}
                      />
                    </div>
                    <div
                      className="modal__body"
                      style={{ paddingTop: 55, paddingBottom: 20 }}
                    >
                      <span
                        className="lnr lnr-cross-circle modal__title-icon"
                        style={{ color: "red" }}
                      />
                      <h5>{this.state.failed_message} </h5>
                    </div>
                    <ButtonToolbar className="modal__footer">
                      <Button
                        style={{ backgroundColor: "#24d6a3", color: "#fff" }}
                        className="modal_ok"
                        onClick={this.Failedtoggle}
                      >
                        Ok
                      </Button>
                    </ButtonToolbar>
                </Modal>
                <Modal isOpen={confirmModal} backdrop="static" toggle={this.confirmToggle}>
                    <div className="modal__header">
                      <button
                        className="lnr lnr-cross modal__close-btn"
                        type="button"
                        style={{ right: 15 }}
                        onClick={this.confirmToggle}
                      />
                    </div>
                    <div
                      className="modal__body"
                      style={{ paddingTop: 55, paddingBottom: 20 }}
                    >
                      <span
                        className="lnr lnr-cross-circle modal__title-icon"
                        style={{ color: "red" }}
                      />
                      <h4 style={{padding: 4}}>{this.state.confirmMessage} </h4>
                    </div>
                    <ButtonToolbar className="modal__footer">
                      {/*<Button
                        style={{ backgroundColor: "#24d6a3", color: "#fff" }}
                        className="modal_ok"
                        onClick={this.removeItem}
                      >
                        Ok
                      </Button>*/}
                      
                      <button
                        className="btn"
                        style={{ border: '1px solid #FFCB05', color: '#000', backgroundColor: 'white', marginRight: 12 }}
                        onClick={this.confirmToggle}
                        >
                            NO
                        </button>
                         <button
                          className="btn"
                          style={{ backgroundColor: '#FFCB05', color: '#000', fontWeight: 500 , }}
                          onClick={ () => this.removeItem(this.state.itemIndex, this.state.itemCode)}
                        >
                            YES
                        </button>
                    </ButtonToolbar>
                </Modal>

                <Modal isOpen={this.state.modalAddItem} backdrop="static" toggle={this.toggleAddItem} className="modal-lg">
                  <div className="modal__header" style={{ borderTop: '5px solid #FFCB05', padding: '20px 20px 0', backgroundColor: '#fff' }}>
                    <h5 style={{ fontWeight: 600, textAlign: 'left' }}>{this.state.modalHeading}</h5>
                    <button
                      className="lnr lnr-cross modal__close-btn"
                      type="button"
                      onClick={this.toggleAddItem}
                      style={{ position: 'absolute', right: 15, top: 15, background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: 'black' }}
                    />
                  </div>

                  <div className="modal__body" style={{ padding: '30px 20px 0' }}>
                    <Row id="modalForm" form>
                        <Col md={6}>
                            <FormGroup style={{textAlign: 'left'}}>
                                <Label for="email">S No.</Label>
                                <Input
                                    type="text"
                                    name="sl_num"
                                    id="email"
                                    value={this.state.sl_num}
                                    /*value={posts.length +1}*/
                                    onChange={this.handleChange}
                                    readOnly
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup style={{textAlign: 'left'}}>
                                <Label for="mobile">Item Code</Label>
                                <Input
                                    type="text"
                                    name="item_code"
                                    id="mobile"
                                    value={this.state.item_code}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row id="modalForm" form>
                        <Col md={12}>
                            <FormGroup style={{textAlign: 'left'}}>
                                <Label for="email">Item Description</Label>
                                <Input
                                    type="text"
                                    name="item_description"
                                    id="email"
                                    value={this.state.item_description}
                                    onChange={this.handleChange}
                                    
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row id="modalForm" form>
                        <Col md={6}>
                            <FormGroup style={{textAlign: 'left'}}>
                                <Label for="email">MRP</Label>
                                <Input
                                    type="number"
                                    name="mrp"
                                    id="email"
                                    value={this.state.mrp}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup style={{textAlign: 'left'}}>
                                <Label for="mobile">Item Level Discount</Label>
                                <Input
                                    type="number"
                                    name="item_level_discount"
                                    id="mobile"
                                    value={this.state.item_level_discount}
                                    onChange={this.handleChange}
                                />
                                {this.state.discountError && (
                                    <span style={{ color: 'red', marginTop: 8 }}>
                                        Item level discount cannot be greater than mrp
                                    </span>
                                )}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row id="modalForm" form>
                        <Col md={6}>
                            <FormGroup style={{textAlign: 'left'}}>
                                <Label for="email">Quantity</Label>
                                <Input
                                    type="number"
                                    name="quantity"
                                    id="email"
                                    value={this.state.quantity}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup style={{textAlign: 'left'}}>
                                <Label for="mobile">Pre Tax</Label>
                                <Input
                                    type="number"
                                    name="pre_tax"
                                    id="mobile"
                                    value={this.state.pre_tax}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row id="modalForm" form>
                        <Col md={6}>
                            <FormGroup style={{textAlign: 'left'}}>
                                <Label for="email">Post Tax</Label>
                                <Input
                                    type="number"
                                    name="post_tax"
                                    id="email"
                                    value={this.state.post_tax}
                                    onChange={this.handleChange}
                                    
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup style={{textAlign: 'left'}}>
                                <Label for="mobile">UOM</Label>
                                <Input
                                    type="number"
                                    name="uom"
                                    id="mobile"
                                    value={this.state.uom}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row id="modalForm" form>
                        <Col md={6}>
                            <FormGroup style={{textAlign: 'left'}}>
                                <Label for="email">Cost</Label>
                                <Input
                                    type="number"
                                    name="cost"
                                    id="email"
                                    value={this.state.cost}
                                    onChange={this.handleChange}
                    
                                />
                            </FormGroup>
                        </Col>
                       
                    </Row>
                  </div>

                  <div className="modal__footer" style={{ padding: '20px', display: 'flex', gap: '10px' }}>
                    <button
                      className="btn"
                      style={{ border: '1px solid #FFCB05', color: '#000', backgroundColor: 'white' }}
                      onClick={this.toggleAddItem}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn"
                      style={{ backgroundColor: '#FFCB05', color: '#000', fontWeight: 500 }}
                      onClick={this.handleAddItemSubmit}
                    >
                      {this.state.editingIndex !== null ? 'Update Item' : 'Add Item'}
                    </button>
                  </div>
                </Modal>



              
            </div>
        );
    }
}

export default HorizontalForm;
